import moment from "moment";
import { ImageOutlined, SaveOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useGrapContext } from "services/graphs/GraphProvider";
import {
  HeaderTabsContextProps,
  useHeaderTabsContext,
} from "services/common/HeaderTabsProvider";

type Props = {
  title?: string;
};

export function DownloadGraph({ title }: Props): JSX.Element | null {
  const graphContext: any = useGrapContext();
  const headerTabsContext: HeaderTabsContextProps | null =
    useHeaderTabsContext();

  function convertToCsv(): string {
    const columnDelimiter = ";";
    const lineDelimiter = "\n";
    let result =
      (graphContext?.label ?? "Label") +
      columnDelimiter +
      graphContext?.ref?.chartInstance?.chart?.data?.datasets
        .map((d: any) => d.label)
        .join(columnDelimiter) +
      lineDelimiter;
    Object.values(
      graphContext?.ref?.chartInstance?.chart?.data?.labels
    ).forEach((l: any, index: number) => {
      result += l + columnDelimiter;
      result +=
        graphContext?.ref?.chartInstance?.chart?.data?.datasets
          .map((d: any) => {
            if (d.data[index]) {
              return d.data[index];
            } else {
              return "";
            }
          })
          .join(columnDelimiter) + lineDelimiter;
    });

    return result;
  }

  return (
    <>
      {graphContext?.ref && (
        <Tooltip
          title={<FormattedMessage id="components.downloadGraph.imgTooltip" />}
        >
          <IconButton
            size="small"
            onClick={() => {
              const a = document.createElement("a");
              a.href = graphContext?.ref?.chartInstance?.toBase64Image();
              a.download = `${
                `[${headerTabsContext?.headerTitle?.toUpperCase()}]-[${title?.toUpperCase()}]` ??
                "image"
              }-[${graphContext?.label
                ?.replace(/ /g, "")
                ?.replace(/,/g, "_")}]-${
                graphContext?.timeTitle ?? moment().format("YYYY-MM-DD HH_mm")
              }.png`;

              // Trigger the download
              a.click();
            }}
          >
            <ImageOutlined />
          </IconButton>
        </Tooltip>
      )}
      {graphContext?.ref && (
        <Tooltip
          title={<FormattedMessage id="components.downloadGraph.csvTooltip" />}
        >
          <IconButton
            size="small"
            onClick={() => {
              let csv = convertToCsv();
              if (!csv.match(/^data:text\/csv/i)) {
                csv = "data:text/csv;charset=utf-8," + csv;
              }
              const data = encodeURI(csv);
              const a = document.createElement("a");
              a.href = data;
              a.download = `[${headerTabsContext?.headerTitle?.toUpperCase()}]-[${
                title?.toUpperCase() ?? "data"
              }]-[${graphContext?.label
                ?.replace(/ /g, "")
                ?.replace(/,/g, "_")}]-${
                graphContext?.timeTitle ?? moment().format("YYYY-MM-DD HH_mm")
              }.csv`;

              // Trigger the download
              a.click();
            }}
          >
            <SaveOutlined />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
